module.exports = __webpack_public_path__ + "img/icon_tab_xianshi_active@2x.8c305744.png";